import routes from '@modules/newsletter/newsletter-routes';
import store from '@modules/newsletter/newsletter-store';

export default {
  routes,
  store,
};
